import BaseService from '@/services/base-service';
import { UserModel } from '@/models/user.model';
import HttpService from './http.service';

export default class UserService extends BaseService {
  constructor(httpService: HttpService) {
    super(httpService);
  }

  async create(model: UserModel): Promise<UserModel> {
    return (await this.httpService.post(UserModel, `${this.apiUrl}/users`, model)) as UserModel;
  }

  async update(model: UserModel): Promise<UserModel> {
    return (await this.httpService.put(
      UserModel,
      `${this.apiUrl}/users/${model.id}`,
      model
    )) as UserModel;
  }

  async getAll(): Promise<UserModel[]> {
    return (await this.httpService.get(UserModel, `${this.apiUrl}/users`)) as UserModel[];
  }
}
